export abstract class Mapper<T> {
  abstract apiEndpoint:string;
  abstract toDb(obj:T): any;
  abstract fromDb(obj:any): T;
}